<!--
 * @Author: your name
 * @Date: 2022-04-18 10:21:48
 * @LastEditTime: 2022-04-18 20:34:20
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \cacaclo_front_end\src\views\order\list\components\MTStatusList.vue
-->
<template>
    <div class="main bg-white">
      <div>
        <van-checkbox v-model="allChecked" @click="allCheckedChange" checked-color="#99C41C" icon-size=".3rem" v-if="mtActiveStatus.value === 'waiting_payment'" ref="allChecked-checkbox">{{ $t('Order.List.Components.MTStatusList.SelectAll') }}</van-checkbox>
      </div>
      <div v-if="listData.length">
        <div v-for="item in listData" :key="item.kkOrderId" class="product_item">
            <div class="platform f-b">
                <div class="f--c">
                  <van-checkbox v-model="item.checked" style="margin-right:.2rem" @click="value=> itemCheck(item, value)" checked-color="#99C41C" icon-size=".3rem" v-if="mtActiveStatus.value === 'waiting_payment'" :name="item.kkOrderId"></van-checkbox>
                  <img src="@/assets/img/shopify-store.png" style="width:.4rem;height:.4rem;margin-right: .1rem" v-if="item.platformCode === 'SP'">
                  <img src="@/assets/img/kakaclo-store.png" style="width:.4rem;height:.4rem;margin-right: .1rem" v-if="item.platformCode === 'KA'">
                  <img src="@/assets/img/dianjiang-store.png" style="width:.4rem;height:.4rem;margin-right: .1rem" v-if="item.platformCode === 'DJ'">
                  <img src="@/assets/img/shopline.png" style="width:.4rem;height:.4rem;margin-right: .1rem" v-if="item.platformCode === 'SL'">
                  <span>{{ item.platformName }}</span>
                </div>
                <orderStatusTagVue :order="item"></orderStatusTagVue>
            </div>
            <OrderProduct
              v-for="(product) in item.orderItemRender"
              :key="product.kkItemId"
              :productName="product.productName"
              :color="product.color"
              :size="product.size"
              :image="product.imageUrl"
              :price="product.price"
              :quantity="product.productNum"
              :finalAmount="product.finalAmount"
              :product="product"
              style="margin-bottom: .1rem"
              @viewDetail="MTViewDetail(item)"
              />
            <div class="foldText" v-if="item.orderItems.length > 1" @click="itemFoldClick(item)">
              <el-button type="text" style="margin-right: .1rem;">{{item.orderItems.length}} {{ $t('Order.List.Components.MTStatusList.Products') }}</el-button>
              <i class="el-icon-arrow-down" style="line-height: 40px" v-if="!item.open"></i>
              <i class="el-icon-arrow-up" style="line-height: 40px" v-if="item.open"></i>
            </div>
            <div class="payNowBtn f-c" v-if="item.status === 'waiting_payment'">
              <el-button plain @click="checkEmailBind(item)" style="border-radius: 8px" type="primary">{{ $t('orderList.PayNow') }}</el-button>
            </div>
            <van-divider></van-divider>
        </div>
      </div>
      <div v-else class="emptyData">
        <Empty description="Empty"></Empty>
      </div>

      <div class="batchPayButton f-c-c bg-white" v-if="mtActiveStatus.value === 'waiting_payment' && selectionForPayNow.length >1">
        <el-button type="primary" @click="payNowClickBatch" style="width:80%;height:.8rem;border-radius: 8px">{{ $t('orderList.PayNow') }}</el-button>
      </div>

      <!-- 设置账号 -->
      <AccountSetting ref="accountSetting" @setSuccess="setSuccess"></AccountSetting>

    </div>
</template>

<script>
import API from '@/api'
import OrderProduct from '@/components/mobile/OrderProduct.vue'
import Divider from 'vant/lib/divider'
import 'vant/lib/divider/style'
import Empty from 'vant/lib/empty'
import 'vant/lib/empty/style'
import Checkbox from 'vant/lib/checkbox'
// import CheckboxGroup from 'vant/lib/checkboxgroup '
import 'vant/lib/checkbox/style'
// import 'vant/lib/checkboxgroup/style'
import Status from '@/components/mobile/Status.vue'
// import bus from '@/util/bus'
import orderStatusTagVue from './orderStatusTag.vue'
import AccountSetting from '@/views/personal-center/account-setting/components/AccountSetting.vue'

export default {
  props: {
    mtActiveStatus: {
      type: Object,
      default: () => ({ name: 'All Orders', value: 'all_order' })
    }
  },
  components: {
    OrderProduct, 'van-divider': Divider, Empty, 'm-status': Status, 'van-checkbox': Checkbox, orderStatusTagVue, AccountSetting
  },
  data() {
    return {
      listData: [],
      searchParams: {
        pageSize: 20,
        pageNumber: 1
      },
      total: 0,
      status: [],
      storeId: [],
      storeSelectList: [],
      selectionForPayNow: [],
      allChecked: false,
      row: undefined
    }
  },
  created() {
    this.getList()
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('scroll', this.scrollEvent)
    })
  },
  destroyed() {
    window.removeEventListener('scroll', this.scrollEvent)
  },
  methods: {
    getParams() {
      const params = Object.assign({}, this.searchParams, this.statusSelectMap())
      return params
    },
    async getList() {
      const params = this.getParams()
      const loading = this.$loading.service()
      try {
        const res = await API.orderGetList(params)
        const list = res.data.list
        list.forEach(product => {
          this.itemHandle(product)
        })
        this.listData = this.listData.concat(res.data.list)
        this.total = res.data.total
        // 参数状态
        this.searchContentStatus = false
        Object.keys(params).forEach(key => {
          if (!['pageSize', 'pageNumber', 'status'].includes(key)) {
            if (params[key]) this.searchContentStatus = true
          }
        })
        this.allChecked = this.listData.every(e => e.checked)
        loading.close()
      } catch (error) {
        loading.close()
        this.$message.error(error.message)
      }
    },
    // 数据格式处理
    itemHandle(item) {
      // 计算待支付是否过支付时间
      if (item.status === 0 && item.purchaseDate && typeof item.purchaseDate === 'number') {
        let overTime = item.purchaseDate + (1000 * 60 * 60 * 24 * 5)
        let currentTime = new Date().getTime()
        if (overTime < currentTime) {
          item.status = 'cancel'
        }
      }
      // 图片格式转换
      item.orderItems.forEach(p => {
        if (p.sizeImagePath && p.sizeImagePath.includes('[')) {
          let sizeImagePath = JSON.parse(p.sizeImagePath)
          let type = Object.prototype.toString.call(sizeImagePath).slice(8, -1)
          if (type === 'Array' && sizeImagePath.length) {
            p.sizeImagePath = sizeImagePath[0].imgUrl
          } else if (type === 'String') {
            p.sizeImagePath = sizeImagePath
          }
        }
        // 变体格式转换
        let options_render = ''
        const options = JSON.parse(p.options).map(e => JSON.parse(e))
        options.forEach(e => this.$set(p, e.name, e.value))
        JSON.parse(p.options).forEach(option => { options_render += `${JSON.parse(option).value}、` })
        options_render = options_render.slice(0, -1)
        this.$set(p, 'options_render', options_render)
      })
      // 添加属性  数据展开折叠使用
      this.$set(item, 'orderItemRender', item.orderItems.slice(0, 1))
      this.$set(item, 'open', false)
      this.$set(item, 'checked', false)
    },
    scrollEvent(e) {
      let scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      let windowHeight = document.documentElement.clientHeight || document.body.clientHeight
      let scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight
      let isBottom = scrollTop + windowHeight - scrollHeight > -1
      if (!isBottom) return
      if (this.listData.length < this.total) {
        this.searchParams.pageNumber++
        this.getList()
      }
    },
    resetPage() {
      this.listData = []
      this.searchParams.pageNumber = 1
      this.selectionForPayNow = []
      this.getList()
    },
    MTViewDetail(item) {
      this.$router.push({
        path: '/order/details',
        query: {
          kkOrderId: item.kkOrderId
        }
      })
    },
    // 列表折叠按钮
    itemFoldClick(item) {
      item.open = !item.open
      if (item.open) {
        item.orderItemRender = item.orderItems
      } else {
        item.orderItemRender = item.orderItems.slice(0, 1)
      }
    },
    /**
     * 根据订单状态获取Status组件的颜色
     */
    getColor(status) {
      const map = {
        'Awaiting payment': 'orange',
        'Pending': 'blue',
        'Delivered': 'blue',
        'Complete': 'green',
        'Refunding': 'red',
        'Refunded': 'red',
        'Canceled': 'gray',
        'Shipped': 'violet'
      }
      return map[status] || 'default'
    },
    itemCheck(item, value) {
      // this.$set(item, 'checked', value)
      this.allChecked = this.listData.every(e => e.checked)
      if (value && item.checked) {
        this.selectionForPayNow.push(item)
      } else {
        let index = this.selectionForPayNow.findIndex(e => e.kkOrderId === item.kkOrderId)
        index !== -1 && this.selectionForPayNow.splice(index, 1)
      }
    },
    payNowClickBatch() {
      // kkOrderId、totalAmount传所有 其他传第一个
      const kkOrderIds = this.selectionForPayNow.map(e => e.kkOrderId)
      const totalAmount = this.selectionForPayNow.reduce((current, next) => {
        return current + next.totalAmount * 1000
      }, 0)
      const orderItemsMore = this.selectionForPayNow.map(e => e.orderItems)
      const product = {
        productName: this.selectionForPayNow[0].orderItems[0].productName,
        productNum: this.selectionForPayNow[0].orderItems[0].productNum,
        skuCode: this.selectionForPayNow[0].orderItems[0].skuCode,
        platformCode: this.selectionForPayNow[0].platformCode,
        totalAmount: totalAmount / 1000,
        kkOrderIds,
        orderItemsMore
      }
      this.$emit('MTPayNow', { product, isBatch: true })
    },

    checkEmailBind(row) {
      this.row = row
      if (!this.$store.state.common.email) {
        this.$refs.accountSetting.show('bindEmail')
      } else {
        this.payNowClick(row)
      }
    },
    setSuccess() {
      this.payNowClick(this.row)
    },

    // 打开支付弹窗
    payNowClick(row) {
      row.productName = row.orderItems[0].productName
      row.productNum = row.orderItems[0].productNum
      row.skuCode = row.orderItems[0].skuCode
      row.kkOrderIds = [row.kkOrderId]
      this.$emit('MTPayNow', { product: row, isBatch: false })
    },
    statusSelectMap() {
      const params = {}
      switch (this.mtActiveStatus.value) {
        case 'all_order':
          console.log('all_order列表内')
          break
        case 'waiting_payment':
          params.status = ['waiting_payment']
          break
        case 'waiting_to_ship':
          params.fulfillmentStatus = ['waiting_to_ship']
          params.status = ['processing']
          break
        case 'in_transit':
          params.fulfillmentStatus = ['fully_shipped', 'partial_shipped']
          break
        case 'Refund&Return':
          params.refundStatus = ['refunding', 'partial_refund', 'refunded']
          break
        case 'completed':
          params.status = ['completed']
          break
        case 'cancel':
          params.status = ['cancel']
          break
        case 'order_info_missing':
          params.status = ['abnormal_order']
          break
        default:
          break
      }
      return params
    },
    allCheckedChange(value) {
      this.$nextTick(() => {
        if (this.allChecked) {
          this.listData.forEach(e => (e.checked = true))
          this.selectionForPayNow = this.listData.slice(0)
        } else {
          this.listData.forEach(e => (e.checked = false))
          this.selectionForPayNow = []
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.main {
  padding: .3rem;
}
/deep/.van-tag {
  height: .6rem;
}
/deep/.van-tag--warning {
  background-color: #FFF6EE;
  color: #F9973C;
}
.CanceledColor {
  background-color: #F1F1F1;
  color: #8B93A3;
}
.ShippedColor {
  background-color: #FFEBFB;
  color: #DC3CBD;
}
.van-tag--primary {
  background-color: #E9F2FF;
  color: #296AC7;
}
.payNowBtn {
  width: 100%;
  padding-top: 0.2rem;
  /deep/.el-button {
    width: 6rem;
    background-color: #FFFFFF;
  }
}
.platform{
  padding-bottom: 0.15rem;
  // /deep/.van-checkbox__icon{
  //   line-height: .3rem;
  //   display: flex;
  //   align-items: center;

  // }
  // /deep/.van-icon{
  //     width: .3rem;
  //     height: .3rem;
  //     line-height: .3rem;
  //   }
}
.batchPayButton {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  height: 1rem;
}
</style>
